<template>
  <div>
      <div class="row" id="ReportProduct">
        <div class="col-12">
          <TitlePage :title="title" :items="items"> </TitlePage>
        </div>
        <div class="col-12 d-flex pb-4">
          <SelectLocation
            :value="listLocation" 
            @getLocation="listLocation = $event, itemReportV3()"
          />
          <date-range-picker
            v-model="dateRange"
            opens="center"
            @update="itemReportV3"
            :ranges="ranges"
            :locale-data="locale"
            :maxDate="locale.maxDate"
            class="dashboard-datepicker"
          >
            <template #ranges="ranges">
              <div class="ranges">
                <ul>
                  <li
                    v-for="(range, name) in ranges.ranges"
                    :key="name"
                    @click="getDate(ranges, range, name)"
                  >
                    <b>{{ name }}</b>
                  </li>
                </ul>
              </div>
            </template>
          </date-range-picker>
        </div>

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-10"><div class="text-bold text-head">Top 7 sản phẩm bán chạy</div></div>
                <div class="col-md-2">
                  <el-select
                    size="medium" class="w-100 pull-right"
                    v-model="sortType"
                    @change="itemReportV3()"
                    placeholder="Kiểu hiển thị">
                    <el-option
                      v-for="item in optionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              
              <apexchart
                v-if="!loading"
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="dataChart.series"
                :options="dataChart.chartOptions"
              />
            </div>
          </div>
        </div>

        <div class="box-loading" v-if="loading">
          <div class="loading">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";
import DateRangePicker from "vue2-daterange-picker";
import moment from "moment";
import SelectLocation from "@/pages/report/components/select-location.vue"
import { ReportService } from "@/services/nextshop/report.service";
import { Bar } from "vue-chartjs"

export default {
  extends: Bar,
  page: {
    title: "Sản phẩm bán chạy",
  },

  components: {
    DateRangePicker,
    SelectLocation
  },

  data() {
    return {
      appId: process.env.VUE_APP_ID,
      listLocation: [VueCookies.get("LID")],
      LID: VueCookies.get("LID"),
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      title: "SẢN PHẨM BÁN CHẠY",
      items: [
        { text: "Báo cáo sản phẩm", href: "/report-product" },
        { text: "Sản phẩm bán chạy", active: true },
      ],
      locale: {
        maxDate: moment().format('YYYY-MM-DD'),
        format: "dd/mm/yyyy",
        applyLabel: "Xác nhận",
        cancelLabel: "Hủy",
        daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
        monthNames: [
          "Tháng 1",
          "Tháng 2",
          "Tháng 3",
          "Tháng 4",
          "Tháng 5",
          "Tháng 6",
          "Tháng 7",
          "Tháng 8",
          "Tháng 9",
          "Tháng 10",
          "Tháng 11",
          "Tháng 12",
        ],
      },
     
      loading: false,
      dimensionTime: "DAY",
      
      categories: [],

      dateRange: {
        startDate:moment().subtract(30, "day")._d,
        endDate: moment().subtract(0, "day")._d
      },
      sortType: 'quantityDesc',
      optionType: [
        {value: 'quantityDesc', label: 'Theo số lượng'},
        {value: 'netRevenueDesc', label: 'Theo doanh thu'},
        {value: 'profitDesc', label: 'Theo lợi nhuận'}
      ],
      dataNumItem: [],
      
      dataChart: {
        responsive: [
          {
            options: {},
          },
        ],
        title: {},
        series: [
          {
            name: "Số lượng",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              columnWidth: 50,
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 3,
          },
          colors: ["#556ee6", "#34c38f"],
          markers: {
            size: [5],
          },
          xaxis: {
            labels: {
              formatter(value) {
                return new Intl.NumberFormat().format(value);
              },
            },
            categories: [],
          },
          yaxis: {
            labels: {
              formatter(value) {
                return value;
              },
            },
            title: {
              text: "Số lượng",
              style: {
                fontWeight: "400",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          tooltip: {
            y: {
              formatter: function(value) {
                return new Intl.NumberFormat().format(value);
              },
            },
          },
        }
      },
      isRealtime: true
    }
  },

  async created() {
    await this.itemReportV3()
  },

  computed: {
    ranges() {
      return {
        "Hôm nay": [moment()._d, moment()._d],
        "Hôm qua": [
          moment().subtract(1, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "7 ngày trước": [
          moment().subtract(7, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "30 ngày trước": [
          moment().subtract(30, "days")._d,
          moment().subtract(1, "days")._d,
        ],
        "Tuần trước": [
          moment().subtract(1, "week").startOf("week")._d,
          moment().subtract(1, "week").endOf("week")._d,
        ],
        "Tháng trước": [
          moment().subtract(1, "month").startOf("month")._d,
          moment().subtract(1, "month").endOf("month")._d,
        ],
        "3 tháng trước": [
          moment().startOf("month").subtract(3, "month")._d,
          moment().endOf("month").subtract(1, "month")._d,
        ],
        "Đầu tuần đến nay": [moment().startOf("week")._d, moment().subtract(0, "days")._d],
        "Đầu tháng đến nay": [moment().startOf("month")._d, moment().subtract(0, "days")._d],
        "Đầu năm đến nay": [moment().startOf("year")._d, moment().subtract(0, "days")._d],
      };
    }
  },

  methods: {
    getDate(ranges, range) {
      ranges.clickRange(range);
    },
    async getListDay(data) {
      const dt = data + "01";
      this.dateRange = {
        startDate: moment(dt).startOf("month"),
        endDate: moment(dt).endOf("month"),
      }
    },
    async itemReportV3(){
      this.checkRangDate()
      this.loading = true
      const strLocation = (this.listLocation.length > 0) ? this.listLocation.join() : this.LID
      
      this.dataChart.series[0].data = []
      this.dataChart.chartOptions.xaxis.categories = []
      
      const getParams = {
        "dimensionTime": "DAY",
        "locationId": strLocation,
        "fromDate": moment(this.dateRange.startDate).format('YYYYMMDD'),
        "toDate": moment(this.dateRange.endDate).format('YYYYMMDD'),
        "sort": this.sortType,
        "isRealtime": this.isRealtime,
        "page": 1,
        "perPage": 7
      }
      
      const response = await ReportService.itemReportV3(getParams)
      if(response.success){
       
        response.data.map((item)=>{
          item.amount = this.divisionThousand(item.amount)
          item.netRevenue = this.divisionThousand(item.netRevenue)
          item.profit = this.divisionThousand(item.profit)

          if(this.sortType == 'quantityDesc'){
            this.dataChart.series[0].name = "Số lượng"
            this.dataChart.chartOptions.yaxis.title.text = "Số lượng"
            this.dataChart.series[0].data.push(item.quantity)
          }
          if(this.sortType == 'netRevenueDesc'){
            this.dataChart.series[0].name = "Doanh thu"
            this.dataChart.chartOptions.yaxis.title.text = "Doanh thu"
            this.dataChart.series[0].data.push(item.netRevenue)
          }
          if(this.sortType == 'profitDesc'){
            this.dataChart.series[0].name = "Lợi nhuận"
            this.dataChart.chartOptions.yaxis.title.text = "Lợi nhuận"
            this.dataChart.series[0].data.push(item.profit)
          }

          this.dataChart.chartOptions.xaxis.categories.push(item.itemName)
        })
      }
      this.loading = false
    },
    checkRangDate(){
      const endDate = moment(this.dateRange.endDate).format('YYYYMMDD')
      const currentDate = moment(new Date()).format('YYYYMMDD')
      if(endDate != currentDate){
        this.isRealtime = false
      }else{
        this.isRealtime = true
      }
    }
  }
};
</script>
<style scoped>
  ::v-deep .vue-daterange-picker{min-width: 225px;}
  .text-head{font-size: 16px;}
</style>